import { TradingHour, ParsedBannerOpeningHour } from './types'
import { parseOpeningHours } from './parse-opening-hours'

export const parseCentreBannerHours = function parseCentreBannerHours(
  tradingHours: TradingHour[],
  centreTimeZone: string,
  centreFeatures?: string[]
): ParsedBannerOpeningHour {
  const defaultDay = { hours: [], text: { description: '', isColored: false } }
  const allHours = parseOpeningHours(
    tradingHours,
    centreTimeZone,
    centreFeatures
  )
  const today =
    allHours.find(tradingHour => tradingHour.day === 'Today') || defaultDay
  return {
    text: today.text,
    hours: today.hours.join(', '),
  }
}
